/**
 * data.js — the approved mockup's sample passes (WalletPass `card` shape).
 * Built from DEMO_CARD so the hero person stays in sync with the rest of the site.
 */
import { DEMO_CARD, DEMO_PHOTO_URL } from '../../lib/demoData';
import cardpassLogoUrl from '../../assets/cardpass-logo.svg';
import cardpassIconUrl from '../../assets/cardpass-icon.svg';
import saraPhotoUrl from './assets/sara-alotaibi.jpg';

/** Pass colour sets (bg / fg / label), same palette as the old showcase. */
export const C = {
  white: { bg_color: '#FFFFFF', fg_color: '#0A0A0A', label_color: '#6E6E6E' },
  dark: { bg_color: '#1c1c20', fg_color: '#FFFFFF', label_color: 'rgba(255,255,255,0.55)' },
  blue: { bg_color: '#0C44EF', fg_color: '#FFFFFF', label_color: '#B8C5FF' },
  green: { bg_color: '#0F2E1F', fg_color: '#FFFFFF', label_color: 'rgba(255,255,255,0.55)' },
  wine: { bg_color: '#3B0A1E', fg_color: '#FFFFFF', label_color: 'rgba(255,255,255,0.55)' }
};

/** Swatch order of the demo colour picker (mockup .swb) with their label keys. */
export const SWATCHES = [
  { key: 'white', label: 'cWhite' },
  { key: 'dark', label: 'cDark' },
  { key: 'blue', label: 'cBlue' },
  { key: 'green', label: 'cGreen' },
  { key: 'wine', label: 'cWine' }
];

/** Mohammed Al-Zahrani, Regional Sales Manager (MC-DEMO01). */
export const ME = { ...DEMO_CARD, company: 'CardPass' };
export const ME_DARK = { ...ME, ...C.dark };

export const SARA = {
  id: 'demo-sara',
  serial_number: 'MC-89A12F0B',
  full_name_en: 'Sara Al-Otaibi',
  title_en: 'Partnerships Lead',
  company: 'CardPass',
  phone: '+966 55 310 7742',
  email: 'sara@company.com',
  ...C.blue
};

export const KHALID = {
  id: 'demo-khalid',
  serial_number: 'MC-3FE912AB',
  full_name_en: 'Khalid Al-Harbi',
  title_en: 'Sales Manager',
  company: 'CardPass',
  ...C.wine
};

export const PHOTO_URL = DEMO_PHOTO_URL;
export const SARA_PHOTO_URL = saraPhotoUrl;
export const LOGO_URL = cardpassLogoUrl;
export const ICON_URL = cardpassIconUrl;
